import { type IXSLXImport } from '@principle-theorem/shared';
import type { Row } from 'exceljs';
import {
  type IPayorLabelXSLX,
  PAYOR_LABEL_HEADERS,
} from './payor-label-to-xlsx';

export class XSLXToPayorLabel implements IXSLXImport<IPayorLabelXSLX> {
  headers = PAYOR_LABEL_HEADERS;

  translate(row: Row): IPayorLabelXSLX {
    return {
      sourceId: row.getCell('sourceId').value?.toString() ?? '',
      sourceName: row.getCell('sourceName').value?.toString() ?? '',
      mapTo: row
        .getCell('mapTo')
        .value?.toString() as IPayorLabelXSLX['mapTo'],
    };
  }
}
